import React, { FC } from 'react';
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Typography,
    Chip,
    Tooltip,
    IconButton
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';

import AssessmentTemplateDetailAccordion from './assessment_template_detail_accordion';
import { GroupAccordionProps } from './types';

const AssessmentTemplateGroupAccordion: FC<GroupAccordionProps> = ({
    section,
    canEdit,
    onCreateTemplate,
    onEditGroup,
    onCreateDetail,
    onEditTemplate,
    onEditDetail,
    onRemoveGroup,
    onRemoveTemplate,
    onRemoveDetail,
    getAdequacyChipStyles,
    classes
}) => {
    const { group, panelId, expanded, onToggle, templates, templateCount } = section;

    return (
        <Accordion
            key={panelId}
            className={classes.groupAccordion}
            square
            expanded={expanded}
            onChange={onToggle}
            TransitionProps={{ unmountOnExit: true }}
            style={{ width: '100%' }}
        >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                    <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
                        {group.name}
                    </Typography>
                    <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center' }}>
                        <Chip
                            size="small"
                            label={`${templateCount} template${templateCount === 1 ? '' : 's'}`}
                            color="primary"
                            style={{ backgroundColor: 'rgba(0,0,0,0.08)', color: '#000', marginRight: canEdit ? 8 : 0 }}
                        />
                        {canEdit && (
                            <>
                                <Tooltip title="Add template">
                                    <IconButton
                                        size="small"
                                        onClick={(event) => {
                                            event.stopPropagation();
                                            onCreateTemplate(group);
                                        }}
                                    >
                                        <AddCircleOutlineIcon fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title="Edit group">
                                    <IconButton
                                        size="small"
                                        onClick={(event) => {
                                            event.stopPropagation();
                                            onEditGroup(group);
                                        }}
                                    >
                                        <EditIcon fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title="Remove group">
                                    <IconButton
                                        size="small"
                                        onClick={(event) => {
                                            event.stopPropagation();
                                            onRemoveGroup(group);
                                        }}
                                        disabled={!group.uuid}
                                    >
                                        <DeleteIcon fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                            </>
                        )}
                    </div>
                </div>
            </AccordionSummary>
            <AccordionDetails style={{ display: 'block', width: '100%' }}>
                {templates.length === 0 ? (
                    <Typography variant="body2" style={{ padding: 12 }}>No templates in this group.</Typography>
                ) : (
                    templates.map(templateSection => (
                            <AssessmentTemplateDetailAccordion
                                key={templateSection.panelId}
                                section={templateSection}
                                canEdit={canEdit}
                                onCreateDetail={onCreateDetail}
                                onEditTemplate={onEditTemplate}
                                onEditDetail={onEditDetail}
                                onRemoveTemplate={onRemoveTemplate}
                                onRemoveDetail={onRemoveDetail}
                                getAdequacyChipStyles={getAdequacyChipStyles}
                                classes={{
                                    templateAccordion: classes.templateAccordion,
                                    tableHeaderCell: classes.tableHeaderCell
                                }}
                        />
                    ))
                )}
            </AccordionDetails>
        </Accordion>
    );
};

export default AssessmentTemplateGroupAccordion;
